export namespace AI {
    /** AI场景 */
    export enum AIScene {
        /** 流程审批智能分析 */
        FORM_APPROVE_ANALYSIS,

        /** 表单控件赋值 */
        FORM_CONTROL_VALUE_ASSIGN = 1,
    }

    /** AI指令名称枚举 */
    export enum Commands {
        /** 值表单控件赋 */
        FORM_CONTROL_VALUE_ASSIGN,
    }

    /** AI智能填单配置 */
    export interface IAIAssignSetting {
        recognitionFields: string[];

        recognitionRule: string;

        exampleText: string;

        exampleFiles: Array<{
            fileId: string;
            fileName: string;
            contentType: string;
            contentLength: number;
            sortKey: number;
            thumbnailUrl: string;
        }>;

        disabled: boolean;
    }

    /** AI智能填单识别类型 */
    export enum AIRecognitionType {
        /** 文本 */
        Text = 0,

        /** 文件 */
        File = 1,
    }

    /** AI智能填单识别Prompt */
    export interface IAIAssignPrompt {
        /** 识别内容 */
        content: string;

        /** 识别类型 */
        contentType: AIRecognitionType;
    }

    /** AI智能填单识别字段类型 */
    export enum AIRecognitionFieldType {
        /** 文本 */
        Text = 1,
        /** 数字 */
        Number = 2,
        /** 日期 */
        Date = 3,
        /** 子表 */
        List = 4,
    }

    /** AI识别模板类型 */
    export enum AIRecognitionTemplateType {
        /** 全部模板 */
        All = 0,
        /** 系统模板 */
        System = 1,
        /** 自定义模板 */
        Custom = 2,
    }

    /** ai场景类型 */
    export enum AIFeatureType {
        /** AI填单助手 */
        Extraction = 1,
        /** AI语音录入功能 */
        Asr = 2,
        /** AI识别（OCR文字识别） */
        Ocr = 3,
    }

    /** 样本图片文件类型 */
    export type SampleImageFileType = {
        /** 文件ID */
        fileId: string;
        /** 文件名 */
        fileName: string;
        /** 文件类型 */
        contentType: string;
        /** 文件大小 */
        contentLength: number;
        /** 缩略图 */
        thumbnailUrl: string;
        /** sort */
        sortKey?: number;
        /** 源文件 */
        source?: File;
        /** 存储key */
        storageKey?: string;
        /** 进度 */
        percent?: number;
        /** 上传状态 */
        status?: string;
    };

    /** AI识别模板模型 */
    export type IAIRecognitionTemplateModel = {
        /** 模板编码 */
        code?: string;
        /** 模板名称 */
        name: string;
        /** 模板描述 */
        description: string;
        /** 样本图片 */
        sampleImage?: string;
        /** 样本文件 */
        sampleFile?: SampleImageFileType;
        /** 模板类型 */
        type: AIRecognitionTemplateType;
        /** 主表 */
        table: {
            /** 字段 */
            fields: ITableTemplateModel[];
        };
        /** 排序 */
        sortIndex: number;
    };

    export type ITableTemplateModel = {
        id?: string;
        /** 字段名称 */
        name: string;
        /** 字段描述 */
        description: string;
        /** 字段类型 */
        type: AIRecognitionFieldType;
        /** 子表 */
        subTable?: {
            fields: ITableTemplateModel[];
        };
    };

    export namespace Request {
        export type IAIRecognitionTemplate = {
            /** 模板编码 */
            code?: string;
            /** 模板名称 */
            name: string;
            /** 模板描述 */
            description: string;
            /** 样本图片 */
            sampleImage?: string;
            /** 模板类型 */
            type: AIRecognitionTemplateType;
            /** 主表 */
            table: {
                /** 字段 */
                fields: ITableTemplateModel[];
            };
            /** 排序 */
            sortIndex: number;
        };
    }

    export namespace Response {
        export type IAIRecognitionTemplateDetail = {
            code: string;
            name: string;
            description: string;
            sortIndex: number;
            type: AIRecognitionTemplateType;
            icon: string;
        };

        export type IAIRecognitionTemplateDefinitions = IAIRecognitionTemplateModel & {
            sampleImage: SampleImageFileType;
        };

        export type IAIRecognitionOcrExtraction = {
            name: string;
            value: string;
            children?: IAIRecognitionOcrExtraction[][];
        };

        /** 使用日志模型 */
        export type IFeatureUsageLogModel = {
            /** 任务id */
            objectId: string;
            /** 引擎编码 */
            engineCode: string;
            /** 表单编码 */
            schemaCode: string;
            /** 表单名称 */
            schemaName: string;
            /** 应用名称 */
            appName: string;
            /** 功能type */
            featureCode: AIFeatureType;
            /** 操作人ID */
            userId: string;
            /** 操作人名称 */
            userName: string;
            /** 操作时间 */
            logTime: string;
            /** 创建时间 */
            createdTime: string;
            /** 消耗次数 */
            creditUsed: number;
        };

        /** 使用日志模型(月统计) */
        export type IMonthlyFeatureUsageLogModel = {
            /** 月份 */
            statMonth: string;
            /** 调用次数 */
            totalCreditUsed: number;
        };

        export type IFeatureRecordModel = {
            /** 获得来源 */
            type: string;
            /** 公司名称 */
            companyName: string;
            /** 购买时间 */
            drpPaidTime: string;
            /** OCR识别次数 */
            ocrCount: number;
            /** 创建时间 */
            createdTime: string;
        };

        /** 启用清单模型 */
        export type IAIEnableModel = {
            /** 应用编码 */
            appCode: string;
            /** 应用名称 */
            appName: string;
            /** 表单编码 */
            schemaCode: string;
            /** 表单名称 */
            schemaName: string;
            /** 控件清单 */
            controlList: Array<{ controlCode: string; controlName: string }>;
        };
    }
}
